/* iBrushy rebuild 2026-10 (L1) - runtime for sections/ib-pdp-*.liquid.
   Own code, no app runtime: sliders (assets/ib-pdp-swiper.js = Swiper 11.0.3, MIT), accordions, tickers,
   videos, dropdowns, variant option swap (Section Rendering API), add to cart via /cart/add.js then
   document event 'ib:cart:open' (the cart drawer listens). Offer selection comes from window.ibOffer (assets/ib-offer.js). */
(() => {
  'use strict';
  if (window.__ibpRuntime) return;
  window.__ibpRuntime = true;

  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const sectionIdOf = (el) => el.closest('.__ibp')?.getAttribute('data-section-id') || null;
  const idClassOf = (el) => Array.from(el.classList).find((c) => /^i[A-Za-z0-9]{16}$/.test(c)) || el.classList[0] || '';
  const formOf = (el) => el.closest('[data-ibp-form-product-url]');

  /* ---------- sliders ---------- */
  const initSliders = (root) => {
    if (typeof window.Swiper !== 'function') return;
    const thumbs = {};
    const build = (el, kind) => {
      if (!el.id || el.swiper) return;
      const paramsEl = document.getElementById(`ibp-slider-${el.id}-params`);
      if (!paramsEl) return;
      let p;
      try { p = JSON.parse(paramsEl.textContent); } catch (e) { return; }
      const sid = sectionIdOf(el);
      const key = `${sid}-${el.getAttribute('data-ibp-slider-id')}`;
      if (sid && p.navigation) {
        p.navigation.nextEl = `[data-section-id='${sid}'] ${p.navigation.nextEl}`;
        p.navigation.prevEl = `[data-section-id='${sid}'] ${p.navigation.prevEl}`;
      }
      if (sid && p.pagination) p.pagination.el = `[data-section-id='${sid}'] ${p.pagination.el}`;
      p.on = p.on || {};
      p.on.changeDirection = (sw) => {
        if (sw.params.direction !== 'horizontal') return;
        const w = el.querySelector(':scope > .ibp-slider-wrapper');
        if (w) w.style.height = '';
      };
      p.on.init = () => el.setAttribute('data-ibp-slider-initialized', 'true');
      if (kind === 'thumbnails') {
        thumbs[key] = new window.Swiper(el, p);
        return;
      }
      if (p.thumbs && thumbs[key]) p.thumbs = { swiper: thumbs[key], ...p.thumbs };
      new window.Swiper(el, p);
      // autoplay sliders: a lazy slide image only starts loading once autoplay moves it inside the slider's clip, so the card
      // shows blank for the whole fetch; fetch the slider's images when it comes near the viewport instead (still lazy for the page).
      if ([p, ...Object.values(p.breakpoints || {})].some((b) => b.autoplay && b.autoplay.enabled !== false)) {
        const io = new IntersectionObserver((es) => {
          if (!es.some((e) => e.isIntersecting)) return;
          io.disconnect();
          el.querySelectorAll('img[loading="lazy"]').forEach((i) => { i.loading = 'eager'; });
        }, { rootMargin: '600px 0px' });
        io.observe(el);
      }
    };
    $$('[data-ibp-type="thumbnails"]', root).forEach((el) => build(el, 'thumbnails'));
    $$('[data-ibp-type="slider"]', root).forEach((el) => build(el, 'slider'));
  };

  /* ---------- accordions ---------- */
  const measure = (items, now) => items.forEach((item) => {
    const c = item.querySelector(':scope > [data-ibp-type="accordion-content"]');
    if (!c) return;
    const td = c.style.transitionDuration;
    c.style.transitionDuration = '0s';
    c.style.setProperty('--ibp-accordion-content-height', 'initial');
    c.style.setProperty('--ibp-accordion-content-width', 'initial');
    const { height, width } = c.getBoundingClientRect();
    c.style.transitionDuration = td;
    c.style.setProperty('--ibp-accordion-content-height', '0');
    c.style.setProperty('--ibp-accordion-content-width', '0');
    const apply = () => {
      if (height) c.style.setProperty('--ibp-accordion-content-height', `${height}px`);
      if (width) c.style.setProperty('--ibp-accordion-content-width', `${width}px`);
    };
    if (now) apply(); else requestAnimationFrame(apply);
  });

  const initAccordions = (root) => {
    const ro = new ResizeObserver(() => measure($$('[data-ibp-type="accordion-item"][data-state="open"]', root), true));
    $$('[data-ibp-type="accordion-container"]', root).reverse().forEach((box) => {
      const multi = box.getAttribute('data-is-multi-open-enabled') === 'true';
      const items = $$(':scope > [data-ibp-type="accordion-item"]', box);
      measure(items, true);
      items.forEach((item) => {
        $$(':scope > [data-ibp-type="accordion-content"] > *', item).forEach((c) => ro.observe(c));
        const head = item.querySelector(':scope > [data-ibp-type="accordion-header"]');
        if (!head) return;
        head.addEventListener('click', () => {
          const open = item.getAttribute('data-state') === 'open';
          item.setAttribute('data-state', open ? 'closed' : 'open');
          if (!open) measure([item]);
          if (!multi) items.forEach((o) => { if (o !== item && o.getAttribute('data-state') === 'open') o.setAttribute('data-state', 'closed'); });
        });
      });
    });
  };

  /* ---------- tickers ---------- */
  const initTickers = (root) => {
    $$('[data-ibp-type="ticker"]', root).reverse().forEach((t) => {
      const first = t.querySelector('.ibp-ticker-initial-child-container');
      const lane = first?.closest('.ibp-ticker');
      const lane2 = lane?.nextElementSibling;
      if (!first || !lane) return;
      const reversed = t.getAttribute('data-ibp-ticker-is-reversed') === 'true';
      const speed = +(t.getAttribute('data-ibp-ticker-speed') || 50);
      const pause = t.getAttribute('data-ibp-ticker-pause') === 'true';
      const kids = first.children;
      const update = () => {
        const tw = Math.min(t.getBoundingClientRect().width, 9999);
        const cw = first.getBoundingClientRect().width;
        const gap = getComputedStyle(first).columnGap || '0px';
        t.style.setProperty('--gap', gap);
        const mult = cw && tw && cw < tw ? Math.ceil(tw / cw) : 1;
        const dur = (cw * mult) / speed;
        if (t.style.getPropertyValue('--multiplier') !== `${mult}`) {
          lane.replaceChildren(first);
          if (lane2) lane2.innerHTML = '';
          [lane, lane2].forEach((box, i) => {
            if (!box) return;
            for (let n = 0; n < Math.max(0, i === 0 ? mult - 1 : mult); n++) {
              Array.from(kids).forEach((k) => box.appendChild(k.cloneNode(true)));
            }
          });
        }
        t.style.setProperty('--play', 'running');
        t.style.setProperty('--direction', reversed ? 'reverse' : 'normal');
        t.style.setProperty('--duration', `${dur}s`);
        t.style.setProperty('--pause-on-hover', pause ? 'paused' : 'running');
        t.style.setProperty('--multiplier', `${mult}`);
      };
      update();
      const ro = new ResizeObserver(update);
      ro.observe(t);
      ro.observe(first);
    });
  };

  /* ---------- videos ---------- */
  const initVideos = (root) => {
    $$('.ibp-video-fill__controls', root).forEach((btn) => {
      const wrap = btn.closest('.ibp-video-fill__wrapper');
      const v = wrap?.querySelector('video');
      if (!v) return;
      btn.addEventListener('click', () => {
        if (v.paused) { v.play(); wrap.setAttribute('data-paused', 'false'); } else { v.pause(); wrap.setAttribute('data-paused', 'true'); }
      });
    });
    $$('article.ibp-video__wrapper', root).forEach((a) => {
      if (a.closest('.ibp-slider-thumbs')) return;
      a.addEventListener('click', () => {
        const src = a.getAttribute('data-src') || '';
        if (a.getAttribute('data-type') === 'external') {
          if (a.querySelector('video')) return;
          const v = document.createElement('video');
          v.className = 'ibp-video__player';
          v.autoplay = true; v.controls = true; v.playsInline = true;
          v.setAttribute('playsinline', 'true');
          v.src = src;
          a.style.setProperty('background-image', 'none');
          a.appendChild(v);
        } else if (!a.querySelector('iframe')) {
          const f = document.createElement('iframe');
          f.className = 'ibp-video__iframe';
          f.src = src;
          f.title = a.getAttribute('data-title') || '';
          f.setAttribute('frameborder', '0');
          f.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture');
          f.setAttribute('allowfullscreen', 'allowfullscreen');
          a.style.setProperty('background-image', 'none');
          a.appendChild(f);
        }
      });
    });
    $$('.ibp-video-fill__wrapper', root).forEach((wrap) => {
      const v = wrap.querySelector('video');
      if (!v) return;
      const p = v.play();
      if (p && p.catch) p.catch(() => {
        const overlay = wrap.querySelector('.ibp-video-fill__overlay');
        const img = document.createElement('img');
        img.src = v.getAttribute('poster') || '';
        img.className = 'ibp-video-fill__video';
        if (overlay) wrap.insertBefore(img, overlay); else wrap.append(img);
      });
    });
  };

  /* ---------- dropdowns (tooltip style) ---------- */
  const placeDropdown = (wrap, ref, placement, offset) => {
    const r = ref.getBoundingClientRect();
    wrap.style.minWidth = `${r.width}px`;
    wrap.style.minHeight = `${r.height}px`;
    wrap.style.setProperty('--ibp-reference-width', `${r.width}px`);
    wrap.style.setProperty('--ibp-reference-height', `${r.height}px`);
    const f = wrap.getBoundingClientRect();
    let side = (placement || 'bottom').split('-')[0];
    const fits = { top: r.top - f.height - offset >= 0, bottom: r.bottom + f.height + offset <= innerHeight };
    if (side === 'top' && !fits.top && fits.bottom) side = 'bottom';
    else if (side === 'bottom' && !fits.bottom && fits.top) side = 'top';
    let x = r.left + r.width / 2 - f.width / 2;
    let y = side === 'top' ? r.top - f.height - offset : r.bottom + offset;
    if (side === 'left' || side === 'right') {
      x = side === 'left' ? r.left - f.width - offset : r.right + offset;
      y = r.top + r.height / 2 - f.height / 2;
    }
    x = Math.max(0, Math.min(x, document.documentElement.clientWidth - f.width));
    wrap.style.left = `${x}px`;
    wrap.style.top = `${y}px`;
    wrap.setAttribute('data-ibp-dropdown-placement', side);
  };

  const initDropdowns = (root) => {
    $$('[data-ibp-type="dropdown"]', root).forEach((dd) => {
      const wrap = dd.parentElement;
      if (!wrap) return;
      wrap.style.setProperty('z-index', getComputedStyle(dd).zIndex);
      dd.style.setProperty('z-index', 'auto');
    });
    $$('[data-ibp-action-type="open-dropdown"]', root).forEach((btn) => {
      const id = btn.getAttribute('data-ibp-action-id');
      const dd = (id && document.querySelector(`.i${id}`)) || btn.closest('[data-ibp-type="dropdown"]');
      const wrap = dd?.parentElement;
      const ref = wrap?.parentElement;
      if (!wrap || !ref) return;
      const placement = dd.getAttribute('data-ibp-dropdown-placement');
      const offset = Number(dd.getAttribute('data-ibp-dropdown-offset')) || 0;
      let timer = 0;
      const follow = () => placeDropdown(wrap, ref, placement, offset);
      const open = () => {
        clearTimeout(timer);
        if (wrap.getAttribute('data-state') === 'open') return;
        wrap.setAttribute('data-state', 'open');
        btn.setAttribute('data-ibp-state', 'active');
        follow();
        addEventListener('scroll', follow, { passive: true });
        addEventListener('resize', follow);
      };
      const close = () => {
        wrap.setAttribute('data-state', 'closed');
        btn.setAttribute('data-ibp-state', 'inactive');
        removeEventListener('scroll', follow);
        removeEventListener('resize', follow);
      };
      btn.__ibpDropdown = { open, close, toggle: () => (wrap.getAttribute('data-state') === 'open' ? close() : open()) };
      if (btn.hasAttribute('data-ibp-action-on-hover')) {
        btn.setAttribute('data-ibp-pointer-grace-leave', 'true');
        btn.addEventListener('mouseenter', open);
        ref.addEventListener('mouseleave', () => { timer = setTimeout(close, 120); });
        wrap.addEventListener('mouseenter', () => clearTimeout(timer));
      }
      document.addEventListener('click', (e) => {
        if (wrap.getAttribute('data-state') === 'open' && !ref.contains(e.target)) close();
      });
    });
  };

  /* ---------- add to cart ---------- */
  const setLoading = (el, on) => {
    el.classList.toggle('ibp-loading', on);
    if (on) { el.style.setProperty('cursor', 'wait'); el.setAttribute('aria-busy', 'true'); } else { el.style.removeProperty('cursor'); el.removeAttribute('aria-busy'); }
  };

  const qtyFromHref = (el) => {
    const m = (el.getAttribute('href') || '').match(/:(-?\d+)/);
    const n = m ? parseInt(m[1], 10) : 1;
    return n > 1 ? n : 1;
  };

  const addToCart = async (btn) => {
    if (btn.getAttribute('data-ibp-disabled') === 'true' || btn.getAttribute('aria-busy') === 'true') return;
    const productId = btn.getAttribute('data-ibp-action-id');
    const section = btn.closest('.__ibp');
    const offer = section && productId ? section.querySelector(`[data-ib-offer][data-product-id="${productId}"]`) : null;
    let items = offer && window.ibOffer ? window.ibOffer.items(offer) : null;
    if (!items || !items.length) {
      const id = btn.getAttribute('data-ibp-action-variant-id') || formOf(btn)?.getAttribute('data-ibp-form-variant-id');
      if (!id) return;
      items = [{ id: Number(id), quantity: qtyFromHref(btn) }];
    }
    setLoading(btn, true);
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        console.warn('[ib-pdp] add to cart refused:', data && (data.description || data.message));
        document.dispatchEvent(new CustomEvent('ib:cart:error', { detail: { items, response: data } }));
        return;
      }
      document.dispatchEvent(new CustomEvent('ib:cart:open', { detail: { items: data.items || [], source: 'ib-pdp' } }));
    } catch (e) {
      console.warn('[ib-pdp] add to cart failed', e);
    } finally {
      setLoading(btn, false);
    }
  };

  /* ---------- variant option swap ---------- */
  const readJson = (id) => {
    const el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  };

  const within = (form, sel) => $$(sel, form).filter((el) => formOf(el) === form);

  const SWAPS = [
    ['[data-ibp-dynamic-content-source]', (a, b) => {
      if (a.tagName === 'IMG') { ['src', 'srcset', 'sizes', 'alt'].forEach((k) => { const v = b.getAttribute(k); if (v == null) a.removeAttribute(k); else a.setAttribute(k, v); }); } else a.innerHTML = b.innerHTML;
    }],
    ['[data-ibp-conditional]', (a, b) => { const s = b.getAttribute('style'); if (s == null) a.removeAttribute('style'); else a.setAttribute('style', s); }],
    ['[data-ibp-action-type="select-variant-option"]', (a, b) => {
      ['data-ibp-state', 'data-ibp-disabled'].forEach((k) => { const v = b.getAttribute(k); if (v == null) a.removeAttribute(k); else a.setAttribute(k, v); });
    }],
    ['[data-ibp-action-variant-id]', (a, b) => {
      ['data-ibp-action-variant-id', 'data-ibp-disabled', 'href'].forEach((k) => { const v = b.getAttribute(k); if (v == null) a.removeAttribute(k); else a.setAttribute(k, v); });
    }],
  ];

  const selectOption = async (el) => {
    const form = formOf(el);
    if (!form) return;
    const sid = sectionIdOf(form);
    const fid = idClassOf(form).replace(/^i/, '');
    const variants = readJson(`variants__${fid}--${sid}`);
    const options = readJson(`options__${fid}--${sid}`);
    if (!variants || !options) return;
    const name = decodeURIComponent((el.getAttribute('data-ibp-option-name') || '').replace(/\+/g, ' '));
    const value = (el.getAttribute('data-ibp-option-value') || '').trim();
    const idx = Math.max(0, options.findIndex((o) => o.name === name));
    const current = variants.find((v) => String(v.id) === form.getAttribute('data-ibp-form-variant-id')) || variants[0];
    const wanted = current.options.slice();
    wanted[idx] = value;
    const next = variants.find((v) => v.options.every((o, i) => o === wanted[i])) || variants.find((v) => v.options[idx] === value);
    if (!next || String(next.id) === form.getAttribute('data-ibp-form-variant-id')) return;
    form.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(form.getAttribute('data-ibp-form-product-url'), location.origin);
      url.searchParams.set('variant', next.id);
      url.searchParams.set('section_id', sid);
      const html = await (await fetch(url.toString())).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const src = Array.from(doc.querySelectorAll(`.i${fid}[data-ibp-form-product-url]`))
        .find((n) => n.getAttribute('data-ibp-form-product-url') === form.getAttribute('data-ibp-form-product-url'));
      if (!src) return;
      SWAPS.forEach(([sel, fn]) => {
        const mine = within(form, sel);
        const theirs = within(src, sel);
        mine.forEach((a, i) => { if (theirs[i]) fn(a, theirs[i]); });
      });
      form.setAttribute('data-ibp-form-variant-id', String(next.id));
      form.dispatchEvent(new CustomEvent('ibp:variant:change', { bubbles: true, detail: { variant: next } }));
    } catch (e) {
      console.warn('[ib-pdp] variant update failed', e);
    } finally {
      form.removeAttribute('aria-busy');
    }
  };

  /* ---------- clicks ---------- */
  const isInteractive = (n) => n instanceof HTMLAnchorElement || n instanceof HTMLButtonElement || n instanceof HTMLInputElement || n instanceof HTMLLabelElement || n instanceof HTMLFieldSetElement;

  document.addEventListener('click', (e) => {
    const el = e.target.closest && e.target.closest('.__ibp [data-ibp-action-type]');
    if (!el) return;
    const type = el.getAttribute('data-ibp-action-type');
    switch (type) {
      case 'add-to-cart':
      case 'add-to-ibp-cart':
        e.preventDefault();
        addToCart(el);
        break;
      case 'scroll-to-section': {
        e.preventDefault();
        const id = el.getAttribute('data-ibp-action-id');
        const target = id && document.getElementById(`i${id}`);
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        break;
      }
      case 'select-variant-option':
        e.preventDefault();
        selectOption(el);
        break;
      case 'open-dropdown':
        if (!el.hasAttribute('data-ibp-action-on-hover') && el.__ibpDropdown) { e.preventDefault(); el.__ibpDropdown.toggle(); }
        break;
      case 'open-page': {
        if (el instanceof HTMLAnchorElement) break; // native link
        let n = e.target;
        while (n && n !== el) { if (isInteractive(n)) return; n = n.parentElement; }
        const href = el.getAttribute('href') || el.getAttribute('data-ibp-href');
        if (!href) break;
        e.preventDefault();
        const url = new URL(href, location.href).href;
        const target = el.getAttribute('target');
        if (target && target !== '_self') window.open(url, target, 'noopener'); else location.href = url;
        break;
      }
      default:
        break;
    }
  });

  /* ---------- boot ---------- */
  const boot = () => {
    const root = document;
    try { initSliders(root); } catch (e) { console.warn('[ib-pdp] slider', e); }
    try { initAccordions(root); } catch (e) { console.warn('[ib-pdp] accordion', e); }
    try { initTickers(root); } catch (e) { console.warn('[ib-pdp] ticker', e); }
    try { initVideos(root); } catch (e) { console.warn('[ib-pdp] video', e); }
    try { initDropdowns(root); } catch (e) { console.warn('[ib-pdp] dropdown', e); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
